import { useForm } from '@mantine/form';
import { Button, Group, Modal, Stack } from '@mantine/core';
import { DatePickerInput } from '@mantine/dates';
import { IconCalendar } from '@tabler/icons-react';
import { startOfDay } from 'date-fns';

interface TerminateParkingContractModalProps {
  opened: boolean;
  onClose: () => void;
  onConfirm: (formValues: TerminateParkingContractFormValues) => void;
  contractEndAt: string;
  isPending: boolean;
}

export interface TerminateParkingContractFormValues {
  terminateDate: string;
}

export default function TerminateParkingContractModal({
  opened,
  onClose,
  onConfirm,
  contractEndAt,
  isPending,
}: TerminateParkingContractModalProps) {
  const form = useForm<TerminateParkingContractFormValues>({
    mode: 'uncontrolled',
    initialValues: { terminateDate: null },
    validate: {
      terminateDate: (value) => {
        if (!value) {
          return ' ';
        }

        if (
          startOfDay(Date.parse(value)) > startOfDay(Date.parse(contractEndAt))
        ) {
          return '手動終止合約時間不可晚於合約結束時間';
        }

        if (startOfDay(Date.parse(value)) < startOfDay(Date.now())) {
          return '手動終止合約時間不可早於今日';
        }
      },
    },
  });

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title="提前終止合約"
      centered
      styles={{ title: { fontWeight: 700, fontSize: 16 } }}
    >
      <form
        onSubmit={form.onSubmit((values: TerminateParkingContractFormValues) =>
          onConfirm(values),
        )}
      >
        <Stack gap="lg">
          <DatePickerInput
            withAsterisk
            label="提前結束日"
            rightSection={<IconCalendar size={14} />}
            rightSectionPointerEvents="none"
            style={{ flex: 1 }}
            placeholder="請選擇結束日"
            valueFormat="YYYY/MM/DD"
            key={form.key('terminateDate')}
            {...form.getInputProps('terminateDate')}
          />
          <Group justify="flex-end">
            <Button type="button" onClick={onClose} variant="outline" fw={400}>
              取消
            </Button>
            <Button type="submit" loading={isPending} fw={400} color="red">
              終止
            </Button>
          </Group>
        </Stack>
      </form>
    </Modal>
  );
}
